<template>
    <b-container class="mt-5 pb-5">
        <b-row class="mt-3 mb-5">
            <b-col>
                <b-link class="link" :to="{name: 'org-dashboard'}"><i class="far fa-long-arrow-left mr-2"></i>Back to Conferences</b-link>
            </b-col>
        </b-row>

        <div v-if="!loading">
            <b-row class="conf-header mb-5" v-if="conference.title">
                <b-col cols="7" v-if="conference.title">
                    <h3 class="text-success">{{conference.title}}</h3>
                    <div>
                        {{conference.startAt | moment('MMM D, YYYY')}} - {{conference.endAt | moment('MMM D, YYYY')}}
                        <b-badge variant="light" class="ml-3"><i class="fas fa-tag mr-2"></i>{{conference.code}}</b-badge>
                    </div>
                </b-col>
                <b-col>
                    <b-card>
                        <h3>{{conference.registrations.length - conference.pending}}</h3>
                        <div>Registrations</div>
                        <div class="text-muted" style="font-size: 0.8rem">{{conference.pending}} Pending</div>
                    </b-card>
                </b-col>
                <b-col>
                    <b-card>
                        <h3>{{conference.revenue | currency}}</h3>
                        <div>Total Revenue</div>
                        <div class="text-muted" style="font-size: 0.8rem">{{conference.pendingRevenue | currency}} Pending</div>
                    </b-card>
                </b-col>
            </b-row>

            <b-nav class="conf-nav mb-5">
                <b-nav-item exact-active-class="active" :to="{name: 'conf-registrations'}"><i class="far fa-users mr-2"></i>Registrations</b-nav-item>
<!--                <b-nav-item exact-active-class="active" :to="{name: 'conf-information'}"><i class="far fa-info-circle mr-2"></i>Information</b-nav-item>-->
                <b-nav-item exact-active-class="active" :to="{name: 'conf-comm', params: {id: conference.id}}"><i class="far fa-comment mr-2"></i>Communicate</b-nav-item>
                <b-nav-item exact-active-class="active" :to="{name: 'conf-sessions'}"><i class="far fa-users-class mr-2"></i>Sessions</b-nav-item>
                <b-nav-item exact-active-class="active" :to="{name: 'conf-edit'}"><i class="far fa-pencil mr-2"></i>Edit</b-nav-item>
            </b-nav>

            <router-view/>
        </div>
        <div v-if="loading">
            <h5 class="text-muted"><i class="fas fa-spinner fa-pulse mr-3"></i>Loading conference details, please wait...</h5>
        </div>
    </b-container>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        name: "conference-details",
        data() {
            return {
                loading: true,
                conference: {
                    registrations: []
                }
            }
        },
        methods: {
            ...mapActions(['getConferenceById', 'activateReg']),
            activate(reg) {
                reg.po_pending = 'false';
                this.activateReg(reg.code)
            },

            getRegByType(registrations, type) {
                return registrations.filter(reg => {
                    switch (type) {
                        case 'all':
                            return true;
                        case 'complete':
                            return (reg.payment_type === 'cc' || (reg.payment_type === 'po' && reg.po_pending === 'false'))
                        case 'pending':
                            return (reg.po_pending === 'true');
                        case 'cc':
                            return (reg.payment_type === 'cc');
                        case 'po':
                            return (reg.payment_type === 'po');
                    }
                });
            }
        },
        mounted: function () {
            this.getConferenceById(this.$route.params.id).then(conf => {
                this.conference = conf;
                this.loading = false;
            }, err => {
                this.conference = {};
                this.loading = false;
                console.error(err);
            });
        }
    }
</script>

<style lang="scss" scoped>
    @import '~@/assets/scss/_variables.scss';

    a.link {
        color: $success;
    }

    .registrations {
        margin-bottom: 8rem;

        .badge {
            padding: 0.3rem 0.4rem 0.2rem;
            margin-left: 0.3rem;
        }

        .registration {
            &:nth-child(odd) {
                background: #f8f9fa;
            }
        }
    }

    @media screen and (max-width: 736px) {

    }
</style>

<style lang="scss">
    @import '~@/assets/scss/_variables.scss';

    .conf-header {
        .card {
            line-height: normal;
        }
    }

    .conf-nav {
        .nav-item {
            margin-right: 1.5rem;

            a {
                padding: 0.2rem;

                color: $success;
                font-size: 1.1rem;

                &.active {
                    border-bottom: 3px solid $success;
                }
            }
        }
    }

    .registrations {
        .nav-item {
            a {
                color: $success;
                font-size: 0.9rem;
            }
        }
    }

</style>
